import _get from 'lodash/get';

import { get } from 'Api';
import store from 'Redux/store';

export function fetchPickAndMix(slug) {
  const language = _get(window, 'locale', 'en');

  return get(store.dispatch, `/pick-and-mix/${slug}/${language}`, true)
    .then(({ response, data }) => {
      if (response.status > 400) {
        return { notFound: true };
      }

      if (data && data.redirect) {
        return { redirect: `${data.redirect}#bundle-ended-${encodeURIComponent(data.name)}` };
      }

      return data;
    });
}

export function fetchPickAndMixPreview(id, key) {
  const language = _get(window, 'locale', 'en');
  let url = `/admin/pick-and-mix/preview/${id}/${language}`;

  if (key) {
    url = `/pick-and-mix/key-preview/${id}/${language}?key=${key}`;
  }

  return get(store.dispatch, url)
    .then(({ response, data }) => {
      if (response.status === 401) {
        alert('Log in as an admin to preview products'); // eslint-disable-line no-alert
        return { notFound: true };
      }
      return data;
    });
}
